import React, { useState } from "react";
import JoinList from "./JoinList";
import JoinSourceType from "./JoinType";


const JoinSource = () => {
  const [activeComponent, setActiveComponent] = useState(localStorage.getItem('JoinList') || "Join Source List");

  // Array with tab names and corresponding components
  const tabs = [
    { name: "Join Source List", component:  <JoinList/>},
    { name: "Join Source Type", component:  <JoinSourceType/>},
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  const changeActiveComponent = (name)=>{
    setActiveComponent(name)
    localStorage.setItem('JoinList',name);
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div style={{zIndex:10}} className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)]">
      <h1 className="text-xl m-4 font-semibold">Join Source</h1>
      <div className="flex gap-2 max-w-100 flex-wrap mb-2">
        {tabs.map(({ name }) => (
          <button
            key={name}
            className={`p-2 rounded-lg text-sm border-b-2 min-w-[100px] ${
              activeComponent === name
                ? "activeBtn text-white"
                : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
            }`}
            onClick={() => {changeActiveComponent(name)}}
          >
            {name}
          </button>
        ))}
      </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default JoinSource;
